import { getDeviceId, getSessionId, isRecentNikeTvVisitor } from 'nike-ui/src/components/dwh-tracking/utils';

export const TIP_CODE = {
    0: 0,
    1: 1,
    2: 3,
    3: 6,
    4: 4,
    5: 5,
    6: 7,
    7: 8,
    8: 9,
    9: 10,
    X: 2,
    x: 2,
    A: 11,
    a: 11,
    B: 12,
    b: 12,
    C: 13,
    c: 13,
    D: 14,
    d: 14,
    E: 15,
    e: 15,
    F: 16,
    f: 16,
    G: 17,
    g: 17,
    H: 18,
    h: 18,
    I: 19,
    i: 19,
    J: 20,
    j: 20,
    K: 21,
    k: 21,
    L: 22,
    l: 22,
    M: 23,
    m: 23,
    N: 24,
    n: 24,
    O: 25,
    o: 25,
    P: 26,
    p: 26,
    Q: 27,
    q: 27,
    R: 28,
    r: 28,
    S: 29,
    s: 29,
    T: 30,
    t: 30,
    U: 31,
    u: 31,
    V: 32,
    v: 32,
    W: 33,
    w: 33,
    Y: 34,
    y: 34,
    Z: 35,
    z: 35,
    undef: 10
};

export function removePick(betId) {
    return ['cmd', ['RemovePick', { betId }]];
}

export function movePickToGroup(betId, targetGroup) {
    return ['cmd', ['MovePick', { betId, targetGroup }]];
}

export function clearBetslip() {
    return ['cmd', ['ClearBetslip', {}]];
}

export function convertBetslip(type) {
    return ['cmd', ['ConvertTo' + type, {}]];
}

export function applyFreeTicket(id) {
    return ['cmd', ['ApplyFreeTicket', { id }]];
}

export function removeExtra() {
    return ['cmd', ['RemoveExtra', {}]];
}

export function submitBet() {
    return [
        'submitBet',
        [
            'PlaceBet',
            {
                nikeTvMetadata: {
                    deviceId: getDeviceId(),
                    sessionId: getSessionId(),
                    watcherNTV: isRecentNikeTvVisitor()
                }
            }
        ]
    ];
}

export function quickSubmitBet(quickBet) {
    return [
        'submitBet',
        [
            'QuickPlaceBet',
            {
                ...quickBet,
                nikeTvMetadata: {
                    deviceId: getDeviceId(),
                    sessionId: getSessionId(),
                    watcherNTV: isRecentNikeTvVisitor()
                }
            }
        ]
    ];
}

export function clearSubmit(keepBets) {
    return ['cmd', ['AckSubmit', { keepBets: keepBets }]];
}

export function setStake(money, type) {
    return ['changeOverallMoneyStake', money, type];
}

export function setAdvantagePercentage(percentage) {
    return ['changeAdvantagePercentage', percentage];
}

export function changeSystemStake(type, money) {
    return ['changeSystemStake', type, money];
}

export function convertToMoneyStake() {
    return ['cmd', ['ConvertToMoneyStake', {}]];
}

export function convertToPointsStake() {
    return ['cmd', ['ConvertToPointsStake', {}]];
}

// TODO: ?? docasne som to sem vratil, lebo ta funkcia sa este pouziva v kode..
export function switchStakeToCombination() {
    return ['cmd', ['SwitchSystemTo', { type: 'Combination' }]];
}

export function switchStakeToBetslip() {
    return ['cmd', ['SwitchSystemTo', { type: 'Betslip' }]];
}

export function toggleTipPopup(betId, actSelectionClass, direction) {
    return ['toggleTipPopup', betId, actSelectionClass, direction];
}

export function toggleAcceptChanges(acceptChanges) {
    return ['cmd', ['ChangeAcceptation', { acceptChanges }]];
}

export function setGridCode(gridPosition, gridValue) {
    return ['cmd', ['SetGridCode', { gridPosition, gridValue }]];
}

export function selectNikeOneBetslip() {
    return ['cmd', ['SetActiveBetslip', null, { betslipNumber: 0 }]];
}

export function selectVirtualBetslip() {
    return ['cmd', ['SetActiveBetslip', null, { betslipNumber: 1 }]];
}

export function toggleCombinations() {
    return ['cmd', ['ToggleCombinations', {}]];
}

export function saveBetslip() {
    return ['cmd', ['SaveBetslip', {}]];
}

export function applyCommand(command) {
    return ['cmd', command];
}
